<template>
  <div class="login-container">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
      autocomplete="on"
      label-position="left"
    >
      <div class="logo-container" style="display:none">
        <img src="@/assets/logo/logo-text.png" class="logo" alt="流向查询">
      </div>
      <div class="title-container">
        <h3 class="title">流向查询系统</h3>
      </div>

      <el-form-item prop="usercode">
        <span class="svg-container">
          <svg-icon icon-class="user-outline"></svg-icon>
        </span>
        <el-input
          v-model="usercodeToUp"
          name="usercode"
          type="text"
          autocomplete="on"
          placeholder="账号"
        />
      </el-form-item>
      <el-form-item prop="password">
        <span class="svg-container">
          <svg-icon icon-class="password-outline"></svg-icon>
        </span>
        <el-input
          :type="pwdType"
          v-model="loginForm.password"
          name="password"
          placeholder="密码"
          @keyup.enter.native="handleLogin"
        />
        <span class="show-pwd" @click="showPwd">
          <svg-icon icon-class="eye-outline"></svg-icon>
        </span>
      </el-form-item>
      <el-form-item>
        <el-button
          :loading="loading"
          type="primary"
          style="width:100%;"
          @click.native.prevent="handleLogin"
        >登录
        </el-button>
      </el-form-item>
      <div class="tips">
        <svg-icon icon-class="tips-outline"></svg-icon>
        <span style="margin-left:5px;">请使用 Chrome 和 Firefox 浏览器打开本网站，以获得最佳体验</span>
      </div>
    </el-form>

  </div>
</template>

<script>
import md5 from 'js-md5'

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        usercode: '',
        password: ''
      },
      loginRules: {
        usercode: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      loading: false,
      pwdType: 'password',
      redirect: undefined
    }
  },

  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },

  computed: {
    // 账号自动转为大写
    usercodeToUp: {
      get() {
        return this.loginForm.usercode
      },
      set(val) {
        this.loginForm.usercode = val.toUpperCase()
      }
    }
  },

  methods: {
    // 显示密码
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = ''
      } else {
        this.pwdType = 'password'
      }
    },

    // 登录事件
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          let params = Object.assign({}, this.loginForm)
          params.password = md5(params.password).toUpperCase()
          this.$store
            .dispatch('Login', params)
            .then(() => {
              this.loading = false
              this.$router.push({ path: this.redirect || '/' })
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          // console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
$bg: #e5e5e5;
$light_gray: #666;

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0;
      -webkit-appearance: none;
      border-radius: 0;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;

      &:-webkit-autofill {
        box-shadow: 0 0 0 1000px $bg inset !important;
        -webkit-box-shadow: 0 0 0 1000px $bg inset !important;
        -webkit-text-fill-color: $light_gray !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: $bg;
    border-radius: 5px;
    color: $light_gray;
  }
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #333;
.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: $bg;

  .login-form {
    position: absolute;
    left: 0;
    right: 0;
    width: 520px;
    max-width: 100%;
    padding: 35px;
    margin: 120px auto;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #000;
  }

  .tips {
    font-size: 12px;
    color: #999;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .logo {
    height: 30px;
  }

  .title-container {
    position: relative;
    text-align: center;

    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 20px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}
</style>
